import FloatContainer from '../../ui-kit/components/wrappers/FloatContainer'
import IconText from '../../ui-kit/components/molecules/IconText'
import {CALENDAR_ICON} from '../../ui-kit/helpers/icons/calendar'
import DropdownSelect from '../../ui-kit/components/atoms/DropdownSelect'
import React from 'react'
import CalendarItem from '../../ui-kit/components/atoms/items/CalendarItem'
import uniqid from 'uniqid'

const DropdownDocument = () => {
  const months = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ]

  const years = [2020, 2021, 2022]

  return (
    <div className="dropdown-document">
      <FloatContainer>
        <IconText
          className="select-template"
          icon={CALENDAR_ICON}
          text="Agosto del 2022"
        />
        <div className="calendar float-container">
          <header className="header-dropdown">
            <DropdownSelect selected="Ago">
              <div className="calendar-item-container three-columns">
                {months.map((month, index) => (
                  <CalendarItem
                    isActive={index === 7}
                    isDisabled={index > 7}
                    key={uniqid()}
                    content={month}
                  />
                ))}
              </div>
            </DropdownSelect>
            <DropdownSelect selected="2020">
              <div className="calendar-item-container three-columns">
                {years.map((year, index) => (
                  <CalendarItem
                    isActive={index === 1}
                    isDisabled={index === 2}
                    key={uniqid()}
                    content={year}
                  />
                ))}
              </div>
            </DropdownSelect>
          </header>
          <div className="calendar-item-container">
            <CalendarItem content="Del 01 al 15" />
            <CalendarItem isActive content="Del 15 al 31" />
          </div>
        </div>
      </FloatContainer>
    </div>
  )
}

export default DropdownDocument
